import { useParams } from "react-router";
import { Forward } from "./Forward";
import { Loading } from "./Loading";
import { NotFound } from "./NotFound";
import { Page } from "./Page";
import { useScrollReset } from "@hooks/useScrollReset";
import { usePageData } from "@hooks/usePageData";
import { useGlobalContext } from "@utils/GlobalContext";
import { isSlugAllowedForLocale } from "@utils/localeRestrictions";

export const PageResolver = () => {
  const { slug = "homepage" } = useParams();
  const { locale, previewContent } = useGlobalContext();
  useScrollReset(slug);
  const isAllowed = isSlugAllowedForLocale(slug ?? "", locale);
  const pageData = usePageData(slug, locale, previewContent, { enabled: isAllowed });

  if (!isAllowed) {
    return <Forward replace to="/" />;
  }

  if (pageData.status === "loading" || !pageData.result) {
    return <Loading />;
  }

  if ("notFound" in pageData.result) {
    return <NotFound />;
  }

  return <Page key={slug} page={pageData.result} />;
};
